var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.0003 24.1667V26.15C20.0003 27.7083 19.3753 28.3333 17.8087 28.3333H13.8503C12.292 28.3333 11.667 27.7083 11.667 26.15V22.1917C11.667 20.625 12.292 20 13.8503 20H15.8337V21.975C15.8337 23.5417 16.4587 24.1667 18.017 24.1667H20.0003Z",
    fill: "#1D894E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M24.1663 19.9999V21.9749C24.1663 23.5416 23.5413 24.1666 21.9747 24.1666H18.0163C16.458 24.1666 15.833 23.5416 15.833 21.9749V18.0166C15.833 16.4583 16.458 15.8333 18.0163 15.8333H19.9997V17.8083C19.9997 19.3749 20.6247 19.9999 22.183 19.9999H24.1663Z",
    fill: "#1D894E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 13.8501V17.8084C28.3333 19.3751 27.7083 20.0001 26.1417 20.0001H22.1833C20.625 20.0001 20 19.3751 20 17.8084V13.8501C20 12.2917 20.625 11.6667 22.1833 11.6667H26.1417C27.7083 11.6667 28.3333 12.2917 28.3333 13.8501Z",
    fill: "#1D894E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIcon);
export default __webpack_public_path__ + "static/media/BIIcon.cf14936e40078dc861e3393a18a98e4e.svg";
export { ForwardRef as ReactComponent };